export const S = {
  app: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top left, rgba(255,255,255,0.42), transparent 30%), linear-gradient(180deg, #b9bfd0 0%, #cfd4df 100%)",
    fontFamily: "var(--font)",
    color: "#20263a",
    paddingBottom: 28,
  },
  topBar: {
    width: "min(1240px, calc(100vw - 24px))",
    margin: "24px auto 0",
    padding: "16px 18px",
    background: "rgba(255,255,255,0.94)",
    border: "1px solid rgba(32, 38, 58, 0.05)",
    borderRadius: 28,
    boxShadow: "0 20px 48px rgba(38, 43, 58, 0.08)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    backdropFilter: "blur(18px)",
  },
  brandMark: {
    width: 40,
    height: 40,
    borderRadius: 14,
    background: "linear-gradient(145deg, #f47643, #ec5c2f)",
    display: "grid",
    placeItems: "center",
    color: "#fff",
    fontWeight: 800,
    fontSize: 14,
    fontFamily: "var(--mono)",
    boxShadow: "0 14px 26px rgba(236, 92, 47, 0.24)",
  },
  shell: {
    width: "min(1240px, calc(100vw - 24px))",
    margin: "14px auto 0",
    padding: "20px 22px 30px",
    background: "rgba(252,253,255,0.95)",
    border: "1px solid rgba(32, 38, 58, 0.05)",
    borderRadius: 32,
    boxShadow: "0 30px 70px rgba(38, 43, 58, 0.1)",
  },
  navBar: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 24,
    padding: 8,
    borderRadius: 22,
    background: "#eef1f7",
  },
  navBtn: {
    border: "none",
    background: "transparent",
    padding: "11px 16px",
    borderRadius: 16,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
    color: "#687287",
    display: "flex",
    alignItems: "center",
    gap: 8,
    transition: "background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease",
  },
  navActive: {
    color: "#20263a",
    background: "#ffffff",
    boxShadow: "0 10px 26px rgba(33, 39, 58, 0.08)",
  },
  content: {
    display: "grid",
    gap: 18,
  },
  pageEyebrow: {
    fontSize: 12,
    letterSpacing: "0.12em",
    fontWeight: 600,
    color: "#ef7442",
    textTransform: "uppercase",
  },
  pageTitle: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    color: "#20263a",
  },
  pageBody: {
    fontSize: 12,
    fontWeight: 400,
    color: "#7d8799",
    lineHeight: 1.6,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.3,
    color: "#20263a",
  },
  card: {
    background: "#ffffff",
    border: "1px solid rgba(32, 38, 58, 0.05)",
    borderRadius: 28,
    boxShadow: "0 22px 48px rgba(32, 38, 58, 0.07)",
  },
  sectionCard: {
    background: "#ffffff",
    border: "1px solid rgba(32, 38, 58, 0.05)",
    borderRadius: 28,
    boxShadow: "0 22px 48px rgba(32, 38, 58, 0.07)",
    padding: 20,
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 14,
    flexWrap: "wrap",
    marginBottom: 18,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#20263a",
    letterSpacing: "-0.02em",
  },
  subtitle: {
    fontSize: 12,
    color: "#7d8799",
    fontWeight: 400,
    lineHeight: 1.6,
  },
  heroPanel: {
    padding: 20,
    borderRadius: 30,
    background:
      "radial-gradient(circle at top right, rgba(126, 165, 215, 0.18), transparent 30%), linear-gradient(180deg, #ffffff 0%, #f7f8fb 100%)",
    border: "1px solid rgba(32, 38, 58, 0.05)",
    boxShadow: "0 24px 50px rgba(32, 38, 58, 0.08)",
    color: "#20263a",
  },
  tileGrid: {
    display: "grid",
    gap: 14,
    gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 170px), 1fr))",
  },
  tile: {
    background: "#ffffff",
    border: "1px solid rgba(32, 38, 58, 0.05)",
    borderRadius: 24,
    padding: 18,
    minHeight: 128,
    boxShadow: "0 18px 38px rgba(32, 38, 58, 0.06)",
  },
  heroTile: {
    background:
      "linear-gradient(180deg, rgba(244,118,67,0.1) 0%, rgba(244,118,67,0.04) 100%)",
    border: "1px solid rgba(244, 118, 67, 0.16)",
    borderRadius: 24,
    padding: 18,
    minHeight: 132,
    boxShadow: "0 18px 38px rgba(236, 92, 47, 0.08)",
  },
  tileLabel: {
    fontSize: 12,
    letterSpacing: "0.11em",
    textTransform: "uppercase",
    color: "#98a1b2",
    fontWeight: 600,
  },
  heroTileLabel: {
    fontSize: 12,
    letterSpacing: "0.11em",
    textTransform: "uppercase",
    color: "#db6f44",
    fontWeight: 600,
  },
  tileValue: {
    fontSize: "clamp(16px, 3vw, 18px)",
    fontWeight: 700,
    color: "#20263a",
    marginTop: 12,
    lineHeight: 1.05,
    letterSpacing: "-0.03em",
    wordBreak: "break-word",
  },
  heroTileValue: {
    fontSize: "clamp(16px, 3vw, 18px)",
    fontWeight: 700,
    color: "#20263a",
    marginTop: 12,
    lineHeight: 1.05,
    letterSpacing: "-0.03em",
    wordBreak: "break-word",
  },
  tileMeta: {
    marginTop: 12,
    fontSize: 12,
    color: "#7d8799",
    lineHeight: 1.55,
  },
  heroTileMeta: {
    marginTop: 12,
    fontSize: 12,
    color: "#7d8799",
    lineHeight: 1.55,
  },
  formGrid: {
    display: "grid",
    gap: 14,
    gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 168px), 1fr))",
  },
  compactGrid: {
    display: "grid",
    gap: 14,
    gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 250px), 1fr))",
  },
  label: {
    display: "block",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#98a1b2",
    marginBottom: 8,
  },
  helperText: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 400,
    color: "#7d8799",
    lineHeight: 1.55,
  },
  warningText: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 600,
    color: "#9c5f08",
    lineHeight: 1.55,
  },
  kpiValue: {
    fontSize: "clamp(16px, 3vw, 18px)",
    fontWeight: 700,
    color: "#20263a",
    lineHeight: 1.05,
    letterSpacing: "-0.03em",
  },
  input: {
    width: "100%",
    borderRadius: 18,
    border: "1px solid #e3e7ef",
    background: "#fbfcfe",
    color: "#20263a",
    padding: "13px 15px",
    fontSize: 14,
    fontFamily: "var(--font)",
    lineHeight: 1.4,
    transition: "border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
    minHeight: 52,
  },
  compactInput: {
    width: "min(240px, 100%)",
    borderRadius: 999,
    border: "1px solid #e3e7ef",
    background: "#fbfcfe",
    color: "#20263a",
    padding: "11px 38px 11px 14px",
    fontSize: 14,
    fontFamily: "var(--font)",
    lineHeight: 1.4,
    transition: "border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
    minHeight: 46,
  },
  textarea: {
    width: "100%",
    borderRadius: 18,
    border: "1px solid #e3e7ef",
    background: "#fbfcfe",
    color: "#20263a",
    padding: "13px 15px",
    fontSize: 14,
    fontFamily: "var(--font)",
    lineHeight: 1.55,
    minHeight: 120,
    resize: "vertical",
  },
  primaryBtn: {
    border: "none",
    borderRadius: 18,
    padding: "13px 18px",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    minHeight: 48,
    color: "#fff",
    background: "linear-gradient(135deg, #ef7442, #ea5c30)",
    boxShadow: "0 16px 28px rgba(236, 92, 47, 0.24)",
  },
  ghostBtn: {
    border: "1px solid rgba(32, 38, 58, 0.08)",
    borderRadius: 18,
    padding: "11px 15px",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    minHeight: 48,
    color: "#20263a",
    background: "#ffffff",
    boxShadow: "0 10px 22px rgba(32, 38, 58, 0.05)",
  },
  subtleBtn: {
    border: "1px solid rgba(32, 38, 58, 0.06)",
    borderRadius: 18,
    padding: "11px 15px",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    minHeight: 48,
    color: "#4a556b",
    background: "#f5f7fb",
  },
  dangerBtn: {
    border: "none",
    borderRadius: 14,
    padding: "9px 12px",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
    color: "#fff",
    background: "#d05a5a",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    borderRadius: 999,
    padding: "7px 11px",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    fontFamily: "var(--mono)",
  },
  activeFilterChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    borderRadius: 999,
    padding: "9px 13px",
    background: "#fff4ee",
    color: "#d96839",
    border: "1px solid rgba(239,116,66,0.16)",
    fontWeight: 600,
    fontSize: 12,
  },
  clearBtn: {
    border: "none",
    background: "none",
    color: "#8a92a3",
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 700,
    padding: 0,
    lineHeight: 1,
  },
  pillRow: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  pillBtn: {
    border: "none",
    background: "#f1f4f9",
    color: "#697487",
    borderRadius: 999,
    padding: "9px 13px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
    boxShadow: "inset 0 0 0 1px rgba(32, 38, 58, 0.04)",
  },
  pillActive: {
    background: "#20263a",
    color: "#fff",
    boxShadow: "0 12px 22px rgba(32, 38, 58, 0.14)",
  },
  tableWrap: {
    overflowX: "auto",
    borderRadius: 24,
    border: "1px solid rgba(32, 38, 58, 0.05)",
    background: "#fff",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 620,
  },
  tableHead: {
    background: "#f8f9fc",
    textAlign: "left",
    fontSize: 12,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    color: "#98a1b2",
    fontWeight: 600,
  },
  tableCell: {
    padding: "12px 14px",
    borderBottom: "1px solid #eef1f6",
    fontSize: 14,
    color: "#263148",
    verticalAlign: "top",
  },
  listCard: {
    display: "grid",
    gap: 12,
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 14,
    flexWrap: "wrap",
    padding: "16px 18px",
    borderRadius: 20,
    border: "1px solid rgba(32, 38, 58, 0.05)",
    background: "#fbfcfe",
  },
  emptyState: {
    textAlign: "center",
    padding: "34px 22px",
    color: "#7d8799",
    borderRadius: 22,
    border: "1px dashed rgba(32, 38, 58, 0.12)",
    background: "#fafbfd",
  },
  loginShell: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background:
      "radial-gradient(circle at top left, rgba(255,255,255,0.36), transparent 28%), linear-gradient(180deg, #b9bfd0 0%, #cfd4df 100%)",
    padding: 20,
  },
  loginCard: {
    width: "min(520px, 100%)",
    padding: 22,
    borderRadius: 32,
    background: "rgba(255,255,255,0.96)",
    boxShadow: "0 34px 72px rgba(32, 38, 58, 0.13)",
    border: "1px solid rgba(255,255,255,0.55)",
  },
  loginBanner: {
    padding: 20,
    borderRadius: 24,
    background:
      "radial-gradient(circle at top right, rgba(255,255,255,0.72), transparent 34%), linear-gradient(180deg, #ffffff 0%, #f6f8fc 100%)",
    color: "#20263a",
    marginBottom: 20,
    border: "1px solid rgba(32, 38, 58, 0.06)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.7)",
  },
  setupList: {
    margin: "14px 0 0",
    paddingLeft: 18,
    color: "#7d8799",
    lineHeight: 1.8,
    fontSize: 13,
  },
  toast: {
    position: "fixed",
    top: 18,
    left: "50%",
    transform: "translateX(-50%)",
    padding: "12px 16px",
    borderRadius: 18,
    fontWeight: 800,
    fontSize: 13,
    zIndex: 100,
    boxShadow: "0 18px 38px rgba(32, 38, 58, 0.14)",
  },
  dropdown: {
    position: "absolute",
    inset: "calc(100% + 6px) 0 auto 0",
    borderRadius: 18,
    background: "#fff",
    color: "#20263a",
    border: "1px solid #e3e7ef",
    boxShadow: "0 18px 36px rgba(32, 38, 58, 0.12)",
    zIndex: 15,
    maxHeight: 220,
    overflowY: "auto",
  },
  dropdownItem: {
    padding: "12px 14px",
    cursor: "pointer",
    borderBottom: "1px solid #eef1f6",
    background: "#fff",
    color: "#20263a",
  },
  chartWrap: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  chartTooltip: {
    position: "absolute",
    background: "#ffffff",
    border: "1px solid rgba(32, 38, 58, 0.08)",
    borderRadius: 16,
    padding: "9px 13px",
    boxShadow: "0 14px 28px rgba(32,38,58,0.12)",
    fontSize: 13,
    fontWeight: 700,
    pointerEvents: "none",
    zIndex: 10,
    color: "#20263a",
    whiteSpace: "nowrap",
    transform: "translate(-50%, -110%)",
    transition: "left 140ms ease, top 140ms ease, opacity 140ms ease, transform 140ms ease",
    willChange: "left, top, transform, opacity",
  },
};
